import { APP_BASE_HREF, CurrencyPipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEnGb from '@angular/common/locales/en-GB';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import {
  APP_AVAILABLE_LANGUAGES,
  APP_CUSTOM_MODULES,
  CoreModule,
  InterceptorsModule,
  ModalModule,
  ModuleTranslateLoaderFactory,
  TranslateCachedService,
  TranslateLoaderReadyService
} from '@cfp/core';
import { BuildingLayout } from '@cfp/domains/building/layout';
import { PortfolioLayout } from '@cfp/domains/portfolio/layout';
import { AuthenticationModule } from '@cfp/features/authentication';
import { CustomerStyling } from '@cfp/features/customer-styling';
import { LbgSharedModule } from '@cfp/features/lbg-shared';
import { BUILDIG_LAYOUT } from '@cfp/shared/building/layout';
import { PORTFOLIO_LAYOUT } from '@cfp/shared/portfolio/layout';
import { LoadingSpinner } from '@cfp/ui/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRouting } from '../../../../shared';
import { environment } from '../environments/environment';

registerLocaleData(localeEnGb, 'en-GB');

const availableLanguages = ['en-GB'];
const customModules = ['mees', 'custom'];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: ModuleTranslateLoaderFactory,
        deps: [HttpClient, APP_CUSTOM_MODULES, TranslateLoaderReadyService, TranslateCachedService]
      }
    }),
    // Routing
    AppRouting,
    // Modules
    CoreModule.forRoot(environment),
    InterceptorsModule.forRoot(),
    AuthenticationModule,
    ModalModule,
    LbgSharedModule.forRoot(),
    LoadingSpinner,
    CustomerStyling
  ],
  providers: [
    DecimalPipe,
    CurrencyPipe,
    {
      provide: APP_BASE_HREF,
      useValue: '/csr/app/lbg/'
    },
    {
      provide: APP_AVAILABLE_LANGUAGES,
      useValue: availableLanguages
    },
    {
      provide: PORTFOLIO_LAYOUT,
      useValue: PortfolioLayout
    },
    {
      provide: BUILDIG_LAYOUT,
      useValue: BuildingLayout
    },
    {
      provide: APP_CUSTOM_MODULES,
      useValue: customModules
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
